var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-block"},[_c('h3',[_vm._v("自定义分组排序")]),_c('el-x-conversations',{attrs:{"items":_vm.customGroupedItems,"groupable":_vm.groupSortOptions,"active":_vm.activeCustomGrouped},on:{"change":_vm.handleCustomGroupedChange}}),_c('div',{staticClass:"demo-description"},[_vm._v(" 可以通过自定义排序函数控制分组的顺序，例如按字母排序或其他逻辑 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }